import {Component, OnInit} from '@angular/core';
import {AppService} from '@services/app.service';
import {AuthService} from '@services/auth.service';

@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
    public user;
    public menu = null;

    constructor(public authService: AuthService) {}

    ngOnInit() {
        this.user = {userId:this.authService.getUserName(), role: this.authService.getRole()};

        if(this.user.role=='ADMIN')
        {
            this.menu = [
                    {
                        name: 'Dashboard',
                        path: ['/admin-dashboard']
                    },
                    {
                        name: 'Main Menu',
                        children: [
                            {
                                name: 'Statewise Overview',
                                path: ['/fsw-status']
                            },
                            {
                                name: 'Vehicles',
                                path: ['/list-vehicle-statewise']
                            },
                
                            {
                                name: 'Trainings',
                                path: ['/list-training-statewise']
                            },
                            {
                                name: 'Testings',
                                path: ['/list-testing-statewise']
                            },
                            {
                                name: 'Awareness Programs',
                                path: ['/list-awp-statewise']
                            },
                            {
                                name: 'Nodal Officers',
                                path: ['/edit-user']
                            },
                            {
                                name:'Product',
                                path:['/new-product']
                            },
                            {
                                name:'Product Vs Parameter',
                                path:['/productVsParameter']
                            },
                            // {
                            //     name:'Monthly Progress Report',
                            //     path:['#']
                            // },
                            {
                                name:'Contact Us',
                                path:['/contact']
                            }
                        ]
                    }
                ];

        }

        if(this.user.role=='IT-TEAM')
        {
            this.menu = [
                    {
                        name: 'Dashboard',
                        path: ['/admin-dashboard']
                    },
                    {
                        name: 'Main Menu',
                        children: [
                            {
                                name: 'Statewise Overview',
                                path: ['/fsw-status']
                            },
                            {
                                name: 'Vehicles',
                                path: ['/list-vehicle-statewise']
                            },
                
                            {
                                name: 'Trainings',
                                path: ['/list-training-statewise']
                            },
                            {
                                name: 'Testings',
                                path: ['/list-testing-statewise']
                            },
                            {
                                name: 'Awareness Programs',
                                path: ['/list-awp-statewise']
                            },
                            {
                                name: 'Nodal Officers',
                                path: ['/edit-user']
                            },
                            {
                                name:'Product',
                                path:['/new-product']
                            },
                            {
                                name:'Product Vs Parameter',
                                path:['/productVsParameter']
                            },
                            {
                                name:'Contact Us',
                                path:['/contact']
                            }
                        ]
                    }
                ];

        }

        if(this.user.role=='USER')
        {
            this.menu = [
                    {
                        name: 'Dashboard',
                        path: ['/fsw-dashboard']
                    },
              
                    {
                        name: 'Main Menu',
                        children: [

                            {
                                name: 'Trainings',
                                path: ['/list-training']
                            },
                            {
                                name: 'Testings',
                                path: ['/list-testing']
                            },
                            {
                                name: 'Awareness Programs',
                                path: ['/list-awp']
                            },
                            {
                                name:'Contact',
                                path:['/contact']
                            }
                        ]
                    }
                ];

        }
        if(this.user.role=='SO')
        {
            this.menu = [
                    {
                        name: 'Dashboard',
                        path: ['/so-dashboard']
                    },
                   
                    {
                        name: 'Main Menu',
                        children: [
                            {
                                name: 'State Overview',
                                path: ['/fsw-status']
                            },
                            {
                                name: 'Vehicles',
                                path: ['/list-vehicle-statewise']
                            },
                
                            {
                                name: 'Trainings',
                                path: ['/list-training-statewise']
                            },
                            {
                                name: 'Testings',
                                path: ['/list-testing-statewise']
                            },
                            {
                                name: 'Awareness Programs',
                                path: ['/list-awp-statewise']
                            },
                            // {
                            //     name:'Monthly Progress Report',
                            //     path:['#']
                            // },
                            {
                                name:'Contact',
                                path:['/contact']
                            }
                        ]
                    }
                ];

        }
        if(this.user.role=='RO')
        {
            this.menu = [
                    {
                        name: 'Dashboard',
                        path: ['/reg-dashboard']
                    },
                   
                    {
                        name: 'Main Menu',
                        children: [
                            {
                                name: 'Vehicles',
                                path: ['/list-vehicle-statewise']
                            },
                
                            {
                                name: 'Trainings',
                                path: ['/list-training-statewise']
                            },
                            {
                                name: 'Testings',
                                path: ['/list-testing-statewise']
                            },
                            {
                                name: 'Awareness Programs',
                                path: ['/list-awp-statewise']
                            },
                            {
                                name:'Contact',
                                path:['/contact']
                            }
                        ]
                    }
                ];

        }
        if(this.user.role=='PMU')
        {
            this.menu = [
                    {
                        name: 'Dashboard',
                        path: ['/admin-dashboard']
                    },
                    {
                        name: 'Main Menu',
                        children: [
                            {
                                name: 'Vehicles',
                                path: ['/list-vehicle-statewise']
                            },
                
                            {
                                name: 'Trainings',
                                path: ['/list-training-statewise']
                            },
                            {
                                name: 'Testings',
                                path: ['/list-testing-statewise']
                            },
                            {
                                name: 'Awareness Programs',
                                path: ['/list-awp-statewise']
                            },
                            {
                                name: 'Nodal Officers',
                                path: ['/edit-user']
                            },
                            {
                                name:'Contact',
                                path:['/contact']
                            }
                        ]
                    }
                ];

        }
    }
}